<template>
  <q-section v-bind="$attrs">
    <q-section wh="100%" p="relative" class="flex justify-center items-center">
      <van-image width="75%" height="75%" round :src="userInfo.avatar_url" style="user-select: none"></van-image>
      <van-image
        class="pos-absolute top-0 left-0"
        width="100%"
        height="100%"
        :src="border"
        style="user-select: none"></van-image>
    </q-section>
  </q-section>
</template>

<script setup lang="ts">
import { useStores } from '@/stores/index'
import { computed } from 'vue'

const store = useStores()
const userInfo = computed(() => store.userInfo)

defineProps({
  border: {
    type: String,
    required: true,
  },
})
</script>

<style scoped lang="scss"></style>
